module.exports = __webpack_public_path__ + "img/GroupN11.32513217.png";